import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import {useTranslation} from "next-i18next";

const dtImages = [
  "/images/Sliceshow-Empuria-01.jpg",
  "/images/Sliceshow-Empuria-02.jpg"
];

const mbImages = [
  "/images/Sliceshow-Empuria-01-mobile.jpg",
  "/images/Sliceshow-Empuria-02-mobile.jpg"
];

export default function HomeMarinaAmMittelmeer() {
  const {t} = useTranslation();
  const slideShow = [
    {
      heading: "Skydive",
      desc: t("marinaCarousel.slideshow.skydive"),
      descL2: t("marinaCarousel.slideshow.skydiveLine2"),
      imageDt: "/images/slideshow/03_sliceshow-Skydive.jpg",
      imageMb: "/images/slideshow/03_sliceshow-Skydive-mobile.jpg",
      url: "https://skydiveempuriabrava.com"
    },
    {
      heading: "Mini Golf Carmanso",
      desc: t("marinaCarousel.slideshow.miniGolf"),
      imageDt: "/images/slideshow/05_sliceshow-Minigolf.jpg",
      imageMb: "/images/slideshow/05_sliceshow-Minigolf-mobile.jpg",
      url: "https://www.minigolfcarmanso.com"
    },
    {
      heading: "Karting Empuriabrava",
      desc: t("marinaCarousel.slideshow.karting"),
      imageDt: "/images/slideshow/09_sliceshow-Karting.jpg",
      imageMb: "/images/slideshow/09_sliceshow-Karting-mobile.jpg",
      url: "https://kartingempuriabrava.com"
    },
    {
      heading: "Casa Museo Salvador Dalí Cadaqués Portlligat",
      desc: t("marinaCarousel.slideshow.casa"),
      imageDt: "/images/slideshow/15_sliceshow-Casa-Dali-Cadaquez.jpg",
      imageMb: "/images/slideshow/15_sliceshow-Casa-Dali-Cadaquez-mobile.jpg",
      url: "https://www.salvador-dali.org/es/visita/casa-salvador-dali"
    },
    {
      heading: "Teatro Museo Salvador Dalí Figueres",
      desc: t("marinaCarousel.slideshow.teatro"),
      imageDt: "/images/slideshow/14_sliceshow-Museo-Dali-Figueres.jpg",
      imageMb: "/images/slideshow/14_sliceshow-Museo-Dali-Figueres-mobile.jpg",
      url: "https://www.salvador-dali.org/es"
    },
    {
      heading: "Casino Peralada",
      desc: t("marinaCarousel.slideshow.casino"),
      imageDt: "/images/slideshow/02_sliceshow-Casino-Peralada.jpg",
      imageMb: "/images/slideshow/02_sliceshow-Casino-Peralada-mobile.jpg",
      url: "https://www.casinoperalada.com"
    },
    {
      heading: "Windoor",
      desc: t("marinaCarousel.slideshow.windoor"),
      imageDt: "/images/slideshow/04_sliceshow-Windoor.jpg",
      imageMb: "/images/slideshow/04_sliceshow-Winddor-mobile.jpg",
      url: "https://www.windoor-realfly.com"
    },
    {
      heading: "Eco Boats",
      desc: t("marinaCarousel.slideshow.eco"),
      imageDt: "/images/slideshow/06_sliceshow-Ecoboats.jpg",
      imageMb: "/images/slideshow/06_sliceshow-Ecoboats-mobile.jpg",
      url: "https://ecoboats.es"
    },
    {
      heading: "Los Barkitos",
      desc: t("marinaCarousel.slideshow.barkitos"),
      imageDt: "/images/slideshow/07_sliceshow-los-barkitos.jpg",
      imageMb: "/images/slideshow/07_sliceshow-los-barkitos-mobile.jpg",
      url: "https://losbarkitos.com"
    },
    {
      heading: "Canals i Mar",
      desc: t("marinaCarousel.slideshow.canals"),
      imageDt: "/images/slideshow/08_sliceshow-Canals-i-Mar.jpg",
      imageMb: "/images/slideshow/08_sliceshow-Canals-i-Mar-mobile.jpg",
      url: "https://canalsimar.com"
    },
    {
      heading: "Aiguamolls",
      desc: t("marinaCarousel.slideshow.aiguamolls"),
      imageDt: "/images/slideshow/10_sliceshow-Aiguamolls.jpg",
      imageMb: "/images/slideshow/10_sliceshow-Aiguamolls-mobile.jpg",
      url: "https://aiguamollsdelemporda.cat"
    },
    {
      heading: "Aquabrava",
      desc: t("marinaCarousel.slideshow.aquabrava"),
      imageDt: "/images/slideshow/11_sliceshow-Aquabrava.jpg",
      imageMb: "/images/slideshow/11_sliceshow-Aquabrava-mobile.jpg",
      url: "http://www.aquabrava.com"
    },
    {
      heading: "Pitch and Putt",
      desc: t("marinaCarousel.slideshow.pitch"),
      imageDt: "/images/slideshow/12_sliceshow-Pitch-and-Putt.jpg",
      imageMb: "/images/slideshow/12_sliceshow-Pitch-and-Putt-mobile.jpg",
      url: "https://golfcastello.com/en/golf-castello-empuriabrava-en"
    },
    {
      heading: "Golf Club Peralada",
      desc: t("marinaCarousel.slideshow.peralada"),
      imageDt: "/images/slideshow/13_sliceshow-Golf-Paralada.jpg",
      imageMb: "/images/slideshow/13_sliceshow-Golf-Paralada-mobile.jpg",
      url: "https://www.golfperalada.com"
    },
    {
      heading: "Butterfly Park",
      desc: t("marinaCarousel.slideshow.butterfly"),
      imageDt: "/images/slideshow/17_sliceshow-Butterfly-Park.jpg",
      imageMb: "/images/slideshow/17_sliceshow-Butterfly-Park-mobile.jpg",
      url: "https://www.butterflypark.es"
    },
    {
      heading: t("marinaCarousel.slideshow.empuriabrava.heading"),
      desc: t("marinaCarousel.slideshow.empuriabrava.desc"),
      imageDt: "/images/slideshow/18_slideshow-Empuria.jpg",
      imageMb: "/images/slideshow/18_slideshow-Empuria-mobile.jpg",
      url: false,
      longText: true
    }
  ];


  return (
    <>
      <div className="w-full flex flex-col items-center relative" id="slideshow">
        <CarouselProvider
          isIntrinsicHeight={true}
          totalSlides={slideShow.length + 1}
          visibleSlides={1}
          infinite={true}
          className="w-full"
          naturalSlideWidth={100}
          naturalSlideHeight={125}
          isPlaying={true}
          interval={5000}
        >
          {/* Slider */}
          <Slider >
            <Slide index={0}>
              <div className="w-full relative">
                <div className="aspect-[3500/4670] lg:aspect-[3500/2306] w-full">
                  <img
                    src="/images/slideshow/01_sliceshow-Empuria.jpg"
                    alt="Empuria"
                    className="w-full h-full  hidden lg:block"
                  />
                  <img
                    src="/images/slideshow/01_sliceshow-Empuria-mobile.jpg"
                    alt="Empuria"
                    className="w-full h-full  block lg:hidden"
                  />
                </div>
                <div className="absolute top-8 lg:top-20 w-full text-white flex flex-col justify-center items-center font-light">
                  <h2 className="leading-none text-[24px] md:text-[55px]">{t("marinaCarousel.topLine1")}</h2>
                  <h2 className="leading-none text-[24px] md:text-[55px]">{t("marinaCarousel.topLine2")}</h2>
                </div>
                <div className="absolute bottom-8 lg:bottom-20 w-full text-white flex flex-col justify-center items-center font-light">
                  <h2 className="leading-none text-[24px] md:text-[55px]">{t("marinaCarousel.botLine1")}</h2>
                  <h2 className="leading-none text-[24px] md:text-[55px] mb-4">{t("marinaCarousel.botLine2")}</h2>
                  <p className="text-center leading-[1.3] font-normal max-w-[90%] lg:max-w-[46%] text-[10px] md:text-[16px]">{t("marinaCarousel.desc")}</p>
                </div>
              </div>
            </Slide>
            {slideShow.map((slide, index) => (
              <Slide key={index} index={index + 1}>
                <div className="w-full relative">
                  <div className="aspect-[3500/4670] lg:aspect-[3500/2306] w-full">
                    <img
                      src={slide.imageDt}
                      alt={slide.heading}
                      className="w-full h-full  hidden lg:block"
                    />
                    <img
                      src={slide.imageMb}
                      alt={slide.heading}
                      className="w-full h-full  block lg:hidden"
                    />
                  </div>
                  <div className="flex justify-center">
                    <div className="absolute bottom-12 lg:bottom-20 w-full px-8 text-white flex flex-col justify-center items-center font-light">
                      <h2 className="leading-[1.2] text-center text-[42px] md:text-[55px] mb-1 lg:mb-4">{slide.heading}</h2>
                      <p className={`leading-[1.2] text-center text-[14px] lg:text-[16px] ${slide.longText ? "max-w-[450px] lg:max-w-[600px]" : "max-w-[320px] lg:max-w-[450px]"} font-normal`}>
                        {slide.desc}

                        {slide.descL2 && (
                          <>
                            <br/>
                            <span>{slide.descL2}</span>
                          </>
                        )}
                      </p>
                      {slide.url && (
                        <a 
                          href={`${slide.url}`}
                          className="h-[40px] px-10 lg:h-[48px] mt-6 lg:mt-4 lg:mt-8 text-[12px] lg:text-[16px] font-bold flex justify-center items-center text-white rounded-[10px] bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent uppercase"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span>{t("marinaCarousel.toWebsite")}</span>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </Slide>
            ))}
          </Slider>

          {/* Buttons */}
          <div className="flex justify-between w-full mt-4 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-4 lg:px-10">
            <ButtonBack className="w-10 h-10 opacity-90">
                <img
                  src="/images/icons/btn-prev.png"
                  alt="Prev"
                />
            </ButtonBack>
            <ButtonNext className="w-10 h-10 opacity-90">
              <img
                src="/images/icons/btn-next.png"
                alt="Next"
              />
            </ButtonNext>
          </div>
        </CarouselProvider>
      </div>
    </>
  );
}